// tab头部分页
import { Case, firstPageIndex } from 'constants/sdk_api';
import { useState } from 'react';

export const usePagination = (list: Case[], pageSize: number) => {
  const [activeKey, setActiveKey] = useState(0);
  const [currentPage, setCurrentPage] = useState(firstPageIndex);

  const totalItems = list.length;
  const totalPages = Math.ceil(totalItems / pageSize);

  // 计算当前页的起始和结束索引,0开始
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, totalItems);

  // 当前页不足每页要求的数量，还需要补充的案例数量
  const additionalCasesCount = pageSize - (endIndex - startIndex);

  // 前一页的后几个案例来填充当前页
  const currentCases = additionalCasesCount > 0 ? list.slice(startIndex - additionalCasesCount, endIndex) : list.slice(startIndex, endIndex);

  // 前后页的切换:前/后一页选中的且还出现在了后/前一页的，需要在后/前一页上继续选中,没有则默认选中第一个
  const handleNextPage = () => {
    // 确保页数不会超过总页数
    setCurrentPage(prevPage => (prevPage % totalPages) + 1);
    setActiveKey(pre => Math.max(0, pre - totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    setActiveKey(pre => (pre + totalPages >= pageSize ? 0 : pre + totalPages));
  };

  return {
    currentCases,
    currentPage,
    totalPages,
    activeKey,
    handleNextPage,
    handlePrevPage,
    setActiveKey,
    setCurrentPage,
  };
};
